"use client";
import { jsx as w } from "react/jsx-runtime";
import { useState as f, useMemo as d, useEffect as R, createContext as M, useContext as P } from "react";
import { useForm as V } from "react-hook-form";
import { useInkeepConversation as k } from "./conversation-provider.js";
import { useModal as I } from "../components/modal/modal-provider.js";
import { getFormDefaultValues as O } from "../utils/form.js";
const j = "root.serverError", p = M(void 0);
function q() {
  const [o, r] = f(null), [h, c] = f(!1), { conversation: n } = k(), S = I(), b = (t) => {
    r(t);
  }, v = () => {
    r(null), c(!1), o?.buttons.close?.action === "close_modal" && S?.setOpen(!1);
  }, i = d(() => o?.fields.map((t) => {
    const s = t;
    return "_type" in t && t._type === "include_chat_session" && (s.isRequired = !1, s.inputType = "checkbox", n.id || (s.isHidden = !0)), s;
  }), [o?.fields, n.id]), a = i?.find((t) => "_type" in t && t._type === "include_chat_session"), e = d(() => O(i), [i]), {
    control: C,
    handleSubmit: F,
    formState: { errors: u, isSubmitting: E },
    setError: _,
    reset: m
  } = V({
    defaultValues: e
  });
  R(() => {
    e && m(e);
  }, [m, e]);
  const x = F(async (t) => {
    const g = n.id && a && t[a.name] ? n : null;
    try {
      await o?.buttons.submit.onSubmit({ values: t, conversation: g }), c(!0);
    } catch (l) {
      _(j, {
        message: l instanceof Error ? l.message : "Something went wrong."
      });
    }
  }), y = u?.root?.serverError;
  return {
    form: o,
    openForm: b,
    closeForm: v,
    handleSubmit: x,
    isSuccess: h,
    isSubmitting: E,
    formError: y,
    fields: i,
    errors: u,
    control: C,
    defaultValues: e
  };
}
const G = ({ children: o }) => {
  const r = q();
  return /* @__PURE__ */ w(p.Provider, { value: r, children: o });
}, J = () => {
  const o = P(p);
  if (!o)
    throw new Error("useChatForm must be used within a ChatFormProvider");
  return o;
};
export {
  G as ChatFormProvider,
  J as useChatForm,
  q as useChatFormState
};
